const state=()=>({
    products:[],
    provider:{}
})

export default {
    namespaced:true,
    state
}